import { Application } from "@hotwired/stimulus";
import { registerControllers } from "stimulus-vite-helpers";

const stimulus = Application.start()
const components = import.meta.globEager("@components/**/*.js")
registerControllers(stimulus, components)
